<template>
  <div class="forget-password">
    <van-form @submit="onSubmit" class="line-form">
      <van-field v-model="userName" class="disabled"
        label="手机号码或邮箱" placeholder="请输入手机号码或邮箱"
        type="text"
        :rules="[{ required: true, message: '请输入手机号码或邮箱' }]"
      />
      <van-field v-model="verifyCode"
        label="获取验证码" placeholder="请输入获取验证码" clearable center
        :rules="[{ required: true, message: '请填写验证码' }]"
      >
        <template #button>
          <van-button plain type="info" native-type="button" size="small" class="code-btn" @click.stop="getSMSCode">
            {{ numCount == 60 ? '获取验证码' : `${numCount}s` }}
          </van-button>
        </template>
      </van-field>
      <van-field v-model="password" class="disabled"
        label="新密码" placeholder="请输入新密码"
        type="password"
        :rules="[{ required: true, message: '请填写新密码' }]"
      />
      <van-field v-model="validPassword"
        type="password" label="确认密码" placeholder="请再次输入密码"
        :rules="[{ required: true, message: '请填写确认密码' }]"
      />
      <div class="btn-group">
        <van-button class="btn-save" block type="info" native-type="submit">保存</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import api from '@/utils/api/personCenter'
import MD5 from 'md5.js'
import commonApi from '@/utils/api/common.js'

export default {
  components: {},
  props: {},
  data() {
    return {
      userName:'',// 用户手机号或邮箱
      password: '',// 新密码
      validPassword: '',// 确认密码
      verifyCode:'',// 验证码
      numCount:60,// 验证码倒计时
    };
  },
  watch: {},
  computed: {
    navTitle() {
      return '修改密码'
    }
  },
  methods: {
    onSubmit() {
      let params = {}

      if(this.password !== this.validPassword){
        this.$toast('两次密码不一致')
        return
      }
      const md5Password = new MD5().update(this.password).digest('hex')
      params.mobileOrEmail = this.userName
      params.newPassword = md5Password
      params.validate = this.verifyCode
      api
        .resetPasswordCenter(params)
        .then(res => {
          console.log(res)
          if(res.code == 0){
            this.$toast('修改密码成功');
            setTimeout(()=>{
              this.$router.go(-1)
            },2000)
          }else{
            this.$toast(res.message)
          }
 
        })
        .catch(err => {
          console.log("err:",err);
          this.$toast(err.response.data.message);
        })
    },
    getSMSCode() {
      if(this.numCount != 60) return
      if(!this.userName) {
        this.$toast('请输入手机号')
        return
      }
      let params = {}
      params.mobileOrEmail = this.userName

      api.checkMobileOrEmailSendCode(params).then(() => {
        this.$toast('发送成功')
        let timer = setInterval(()=> {
          this.numCount--
          if(this.numCount <= 0) {
            clearInterval(timer)
            this.numCount = 60
          }
        }, 1000)
      }).catch(err => {
        console.log("err:",err);
        this.$toast(err.response.data.message);
      })
      
    },
    loadData(){// 获取主数据
      let params = {}
      // 
      
    },
  },
  created() {},
  mounted() {
    this.userInfo = this.$store.state.userInfo ? this.$store.state.userInfo : '';
  }
};
</script>
<style lang="scss" scoped>
.forget-password {
  height: 100vh;
  background-color: #fff;
  .line-form {
    padding: 15px;
    background-color: #fff;
    ::v-deep .van-cell {
      display: block;
      .van-field__label {
        width: 100%;
        padding-bottom: 5px;
      }
      .van-field__value .van-field__body {
        padding: 5px 10px;
        border: 1px solid #ddd;
      }
      &::after {
        border-bottom: 0;
      }
    }
    .btn-group {
      margin: 50px 20px;
      .btn-save{
        background: #1D84FF;
        border-radius: 5px;
      }
    }
  }
}
</style>